<template>
  <div v-if="currentEmploye">
    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Gestion des employés'"
          :description="'Aperçu d\'un employé'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4">
        <Header :currentEmploye="currentEmploye" />
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="$router.push({ name: 'rh_employe' }).catch(() => {})"
        >
          Liste des employés
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router.push({ name: 'rh_employe-create' }).catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouvel employé
        </button>

        <button
          type="button"
          class="btn btn-custom-primary"
          @click.prevent="
            $router
              .push({
                name: 'rh_employe-edit',
                params: { id: currentEmploye.id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-edit font-size-17"></i> Modifier
        </button>
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{
                name: 'rh_employe-show',
                params: { id: currentEmploye.id },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-eye text-custom-primary font-size-17"></i>
              Identité employé</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'rh_employe_show_compte',
                params: { id: currentEmploye.id },
              }"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Compte utilisateur</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'rh_employe_show-document',
                params: {
                  id: currentEmploye.id,
                  documentUuid: currentEmploye.document.uuid,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-paperclip text-custom-primary font-size-17"></i>
              Documents</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'rh_employe_show_contrat',
                params: { id: currentEmploye.id },
              }"
              exact
              exact-active-class="active"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Contrats</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'rh_employe_show_competence',
                params: { id: currentEmploye.id },
              }"
              exact
              exact-active-class="active"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Compétences</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'rh_employe_show_habilitation',
                params: { id: currentEmploye.id },
              }"
              exact
              exact-active-class="active"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Habilitations</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'rh_employe_show_objectif',
                params: { id: currentEmploye.id },
              }"
              exact
              exact-active-class="active"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Objectifs</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'rh_employe_show_planning',
                params: { id: currentEmploye.id },
              }"
              exact
              exact-active-class="active"
              ><i
                class="ion ion-md-calendar text-custom-primary font-size-17"
              ></i>
              Planning</b-nav-item
            >
          </b-nav>
        </div>
      </div>

      <div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header.vue';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      title: 'Gestion des employés - Aperçu',
    };
  },
  computed: {
    ...mapGetters('employe', ['currentEmploye']),
  },
  components: {
    Header,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    ...mapActions('employe', ['getEmploye', 'setEdit']),
    init() {
      this.setEdit(false);
      this.getEmploye({ id: this.$route.params.id, edit: false });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
